import { useCallback } from 'react';

import { QUERY_TOKEN_PARAM_NAME } from '~constants/token';
import { getLocale, getLocalizedUrl } from '~features/language/model/utils';
import { TokenManager } from '~shared/services/ClientTokenManager';
import { getNSFWOrigin, getSFWOrigin, isSafeApp } from '~shared/utils/host';

export const useSafeModeRedirect = () => {
	const redirectTo = useCallback((targetOrigin: string) => {
		const { host, pathname, search } = window.location;
		const locale = getLocale(host);
		const searchParams = new URLSearchParams(search);
		const { token, type } = TokenManager.getInfo();

		if (token && type !== 'demo') {
			searchParams.set(QUERY_TOKEN_PARAM_NAME, token);
		}

		if (locale) {
			searchParams.set('originLocale', locale);
		}

		const url = getLocalizedUrl(searchParams, pathname, locale, targetOrigin);

		window.location.replace(url);
	}, []);

	const redirectToSFWDomain = useCallback(() => {
		redirectTo(getSFWOrigin());
	}, [redirectTo]);

	const redirectToNSFWDomain = useCallback(() => {
		redirectTo(getNSFWOrigin());
	}, [redirectTo]);

	const redirectToAppropriateDomain = useCallback(() => {
		isSafeApp ? redirectToNSFWDomain() : redirectToSFWDomain();
	}, [redirectToNSFWDomain, redirectToSFWDomain]);

	return {
		redirectToAppropriateDomain,
		redirectToNSFWDomain,
		redirectToSFWDomain,
	};
};
